import { render, staticRenderFns } from "./job_fair_details_new.vue?vue&type=template&id=11e5cd58&scoped=true"
import script from "./job_fair_details_new.vue?vue&type=script&lang=js"
export * from "./job_fair_details_new.vue?vue&type=script&lang=js"
import style0 from "./job_fair_details_new.vue?vue&type=style&index=0&id=11e5cd58&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e5cd58",
  null
  
)

export default component.exports